import React from 'react';
import cx from 'classnames';
import * as Meta from '@elevio/kb-kit/lib/components/meta';
import * as Category from '@elevio/kb-kit/lib/components/category';
import * as Article from '@elevio/kb-kit/lib/components/article';
import { IBreadCrumb } from '@elevio/kb-kit/lib/types';
import "./breadcrumbs.scss";
function Breadcrumb({ className, crumbs, noLinks }) {
  return (
    <div className={cx('breadcrumbs', className)}>
      {crumbs.map((crumb, index) => (
        <React.Fragment key={index}>
          <Crumb crumb={crumb} className="link link--black" noLinks={noLinks} />
          {index < crumbs.length - 1 && (
            <span>/</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
function Crumb({ noLinks, crumb, className }) {
  if (noLinks) {
    return <span className={className}>{crumb.title}</span>;
  }
  if (crumb.linkType === 'article') {
    return (
      <Article.Link hidden="" articleId={crumb.linkId} className={className}>
        {crumb.title}
      </Article.Link>
    );
  }
  if (crumb.linkType === 'category') {
    return (
      <Category.Link categoryId={crumb.linkId} className={className}>
        {crumb.title}
      </Category.Link>
    );
  }
  return <Meta.HomeLink className={className}>{crumb.title}</Meta.HomeLink>;
}
export default Breadcrumb;
